import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import {
  Container,
  Theme,
  Text,
  Header,
  CtaButton,
  Row,
  Figure,
  FigureImage,
  Content,
  CloseButton,
  FormContent,
  Overlay,
  Wrapper,
  IMAGE_SIZES,
  ContentWrapper,
  ScrollWrapper,
} from './modal.styles';
import { ModalContainer } from './modalContainer';
import { getImgProps, parseFields } from '../../utils/cmsData';
import { accessibleClickHandler } from '../../utils/accessibility';
import { PlatformDetector } from '../platformDetector/platformDetector.component';
import { ContentRenderer } from '../contentManager';
import {
  MODAL_TEMPLATE,
  BANNER_TO_MODAL_TEMPLATE,
  MODAL_WITH_BUTTONS_TEMPLATE,
} from '../../constants';

export class Modal extends PureComponent {
  static propTypes = {
    contentEntry: PropTypes.object,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    slug: PropTypes.string,
  };

  state = {
    containerHeight: 0,
  };

  componentDidMount() {
    const { contentEntry } = this.props;
    const id = contentEntry.getIn(['sys', 'id']);
    window.dataLayer = window.dataLayer || [];
    if (id && !dataLayer.find(e => e.element === id)) {
      window.dataLayer.push({
        event: 'display',
        elementType: 'modal',
        element: id,
      });
    }
  }
  componentDidUpdate() {
    const { contentEntry } = this.props;
    const id = contentEntry.getIn(['sys', 'id']);
    window.dataLayer = window.dataLayer || [];
    if (id && !dataLayer.find(e => e.element === id)) {
      window.dataLayer.push({
        event: 'display',
        elementType: 'modal',
        element: id,
      });
    }
  }

  renderModalWithButtonsContent = () => {
    const { contentEntry, closeModal } = this.props;
    const id = contentEntry.getIn(['sys', 'id']);
    const { theme: darkTheme, content } = parseFields(contentEntry);
    const theme = darkTheme ? Theme.DARK : Theme.LIGHT;
    return (
      <Row>
        {content.map(link => {
          const url = link.getIn(['fields', 'url', 'fields', 'url']);
          const label = link.getIn(['fields', 'label']);
          return (
            <CtaButton
              url={url}
              smallOnMobile
              buttonType={theme.buttonType}
              {...accessibleClickHandler(() => closeModal(id))}
              onClick={() => closeModal(id)}
            >
              {label}
            </CtaButton>
          );
        })}
      </Row>
    );
  };

  renderModalContent = () => {
    const { contentEntry, closeModal } = this.props;
    const id = contentEntry.getIn(['sys', 'id']);
    const { theme: darkTheme, buttonLabel, buttonUrl } = parseFields(contentEntry);
    const theme = darkTheme ? Theme.DARK : Theme.LIGHT;
    return (
      <CtaButton
        url={buttonUrl}
        smallOnMobile
        buttonType={theme.buttonType}
        {...accessibleClickHandler(() => closeModal(id))}
        onClick={() => closeModal(id)}
      >
        {buttonLabel}
      </CtaButton>
    );
  };

  renderCustomContent = () => {
    const { contentEntry } = this.props;
    const { title, text, template } = parseFields(contentEntry);
    return (
      <Content>
        <Header>{title}</Header>
        <Text>{text}</Text>

        {[MODAL_TEMPLATE, BANNER_TO_MODAL_TEMPLATE].includes(template) && this.renderModalContent()}
        {template === MODAL_WITH_BUTTONS_TEMPLATE && this.renderModalWithButtonsContent()}
      </Content>
    );
  };

  renderFormContent = form => {
    const { contentEntry } = this.props;
    const { theme } = parseFields(contentEntry);

    return (
      <FormContent>
        <ContentRenderer
          content={form}
          componentProps={{ customClass: `form--subscribe-box--small ${theme ? '' : 'light'}` }}
        />
      </FormContent>
    );
  };

  render() {
    const { contentEntry, isOpen, closeModal } = this.props;

    if (!contentEntry.size) {
      return null;
    }

    const id = contentEntry.getIn(['sys', 'id']);
    const { theme: darkTheme, image, form } = parseFields(contentEntry);
    const withForm = !!form;

    const propTheme = darkTheme ? Theme.DARK : Theme.LIGHT;
    const theme = withForm ? Theme.FORM : propTheme;
    const { closeIconMobileColor, closeIconDesktopColor } = theme;

    return (
      <PlatformDetector>
        {({ isMobile, isTabletPortrait }) => (
          <ModalContainer isOpen={isOpen} onClose={() => closeModal(id)} withCloseButton={false}>
            <Overlay />
            <ScrollWrapper>
              <Wrapper isLarge={this.state.containerHeight > window.innerHeight}>
                <ContentWrapper>
                  <Container theme={theme} ref={this.contentEntryRef}>
                    <Figure withForm={withForm}>
                      <FigureImage {...getImgProps(image)} sizes={IMAGE_SIZES} />
                    </Figure>

                    {form
                      ? this.renderFormContent(form, theme)
                      : this.renderCustomContent(contentEntry)}

                    <CloseButton
                      iconColor={
                        isMobile || isTabletPortrait ? closeIconMobileColor : closeIconDesktopColor
                      }
                      {...accessibleClickHandler(() => closeModal(id))}
                    />
                  </Container>
                </ContentWrapper>
              </Wrapper>
            </ScrollWrapper>
          </ModalContainer>
        )}
      </PlatformDetector>
    );
  }
}
